import PropTypes from 'prop-types';
import TeacherStatsShareBar from './TeacherStatsShareBar.js';

function TeacherStatsFooter({ isTeacher, teacherPossessiveScreenName, teacherName, teacherProfileUrl }) {
    const footerText = isTeacher ? 'You\'re doing great! We can\'t wait to see what the future holds' : `Thanks to donors like you, ${teacherName} is able to provide their students the best classroom experience!`;

    function footerButton() {
        return isTeacher
            ? <div className='footer-buttons'>
                <p>
                    <a href="/donors/search.html" className="button-primary small">Browse projects for inspiration</a>
                    <a href="https://help.donorschoose.org/hc/en-us/articles/5281080681751" target="_blank" className="button-secondary small button-overlay" rel="noreferrer">Learn more about your stats</a>
                </p>
            </div>
            : <a href={baseURL + teacherProfileUrl} className="button-primary small">Support {teacherPossessiveScreenName} classroom</a>;
    }

    function showShare() {
        return <>{isTeacher &&
            <TeacherStatsShareBar
                secureBaseURL={window.secureBaseURL}
                shareURL={window.shareURL} // Defined globally as a pageSpecificJsVariables
                facebookAppId={window.facebookAppId}
                getTafEmail={window.getTafEmail} // defined in general/sharebar.js
                getTafURL={window.getTafURL} // defined in general/sharebar.js

                getTrackingLink={window.getTrackingLink} // defined in queryParams.js
            />
        }</>;
    }

    return (
        <footer>
            <div aria-label='star graphic' className='illustration star'></div>
            <div className='confetti-container'>

                <img src='../../../images/teacher/stats/confetti_bottom.svg' alt="congrats!"/>

            </div>

            <h2>
                {footerText}
            </h2>

            {footerButton()}

            <div>
                {showShare()}
            </div>

        </footer>
    );
}

TeacherStatsFooter.propTypes = {
    isTeacher: PropTypes.bool,
    teacherPossessiveScreenName: PropTypes.string,
    teacherProfileUrl: PropTypes.string,
    teacherName: PropTypes.string,
};

export default TeacherStatsFooter;
